import { LitElement, html, css } from 'lit-element'
import FirebaseLoginUiClass from './firebase-login-ui'
import ClipFront from './clip-front'
import GenerateImgClass from './generate-img-ui'
import GenerateImg2Class from './generate-img-2-ui'
import PromptTemplateClass from './prompt-template-ui'
import WordCloudClass from './word-cloud-ui'

//函數
import { subscriberByEmail } from './js/subscriber-api'
// import { quickstart } from './js/text-to-keyword-api.js';
// import { textToSpeechApi } from './js/text-to-speech-api.js';
// import { textToSummary } from './js/text-to-summary-api.js';
// import { gpt2Query } from './js/gpt2-api.js';

//

class MainClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      
      `
    }
    
  render () {
      return html``
  }
  
}

//初始化
// customElements.define('main-ui', MainClass);
customElements.define('firebase-login-ui', FirebaseLoginUiClass);
customElements.define('clip-front', ClipFront);
customElements.define('generate-img-ui', GenerateImgClass);
customElements.define('generate-img-2-ui', GenerateImg2Class);
customElements.define('prompt-template-ui', PromptTemplateClass);
// customElements.define('word-cloud-ui', WordCloudClass);

if(document.getElementById("index-page")) 
{ 
  
  var clipFrontEle=document.getElementById('clip-front')
  var generateImgEle=document.getElementById('generateImgBtn')
  var yourLoginStateEle=document.getElementById('yourLoginState');
  
  var userSettingBtnEle=document.getElementById('userSettingBtn');
  


  //默認隱藏
  document.getElementById('generate-img-ui').style='display: none;';
  document.getElementById('generate-img-2-ui').style='display: none;';
  document.getElementById('prompt-template-ui').style='display: none;';

  //
  // clipFrontEle.addEventListener('click',()=>{
  //   document.getElementById('clip-front').style='display: block;';
  //   document.getElementById('generate-img-ui').style='display: none;';
  // });
  generateImgEle.addEventListener('click',()=>{
    
    if(yourLoginStateEle.value=='0'){
        alert('please log in first')
        return;
    }
    
    document.getElementById('generate-img-ui').style='display: block;';
    document.getElementById('clip-front').style='display: none;';
    document.getElementById('generate-img-2-ui').style='display: none;';
    
  });

  userSettingBtnEle.addEventListener('click',()=>{
    if(yourLoginStateEle.value=='0'){
      alert('please log in first')
    }else{
      // document.getElementsByClassName('userSettingA').href='user-setting.html';
      window.location.replace('https://'+window.location.host+'/user-setting.html') 
    }
  });


}

